export default __webpack_public_path__ + "static/media/ad_468x60_install@2x.42cda39e.png";